import type { FC, ReactNode } from 'react'

import { heroFeatures } from '@/constants/content'

export const FeatureStrip: FC = (): ReactNode => {
    return (
        <section className='feature-section padding'>
            <div className='w-layout-blockcontainer hero-container feature w-container'>
                <div className='feature-wrapper' data-reveal-stagger='0.12'>
                    {heroFeatures.map((feature) => (
                        <div
                            key={feature.title}
                            id={'nodeId' in feature ? feature.nodeId : undefined}
                            className='single-feature'
                        >
                            <div className='feature-icon-box'>
                                <img src={feature.icon} loading='lazy' alt='' />
                            </div>

                            <div className='feature-title-wrapper'>
                                <p className='feature-title'>
                                    {feature.title}
                                </p>

                                <p className='feature-subtitle'>
                                    {feature.subtitle}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
